import { swalToast } from './swal'

export function copy(value: string) {
  navigator.clipboard.writeText(value).then(() => {
    swalToast.fire({ text: 'コピーしました' })
  })
}
